import styled from 'styled-components';

export const StyledCanvas = styled.div`
  flex-grow: 1;
  :focus {
    outline: none;
  }
`;

export const StyledControlsContainer = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #c6c6c6;
`;

export const StyledControlsButton = styled.button`
  padding: 4px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  :hover {
    background-color: #f0f0f0;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
